function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useRef, useState } from 'react';
import { Avatar, Button, Card, Checkbox, Flex, FileUpload, FileList, Heading, HelpText, Link, Markdown, MenuButton, Switch, Text, TextInput, Tooltip, Dialog, useId, useToasts, Tag, Notice, Box, RichTextEditor, validateMarkdownAccessibility, GridAlpha, StickyBar, Badge } from '@applyboard/crystal-ui';
import { AttachFileOutlineIcon, CheckMarkOutlineIcon, CopyOutlineIcon, DeleteOutlineIcon, DocumentCheckOutlineIcon, MagicWandOutlineIcon, MoreVertOutlineIcon, PlusOutlineIcon, ReplyOutlineIcon, ThumbDownOutlineIcon, ThumbUpOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker, useTranslation } from '@applyboard/ui-utils';
import { useCardStyle } from "./useCardStyle";
import { useUploadAttachment } from "../../../../data/attachments";
import { useApplication, useApplicationAvailableActions, useCancelApplication, useLegacyApplication } from "../../data";
import { useNotes, useNote, useUpdateNote, useNoteUser, useDeleteNote, useAcceptAbbieNote, isNoteContentCreationFailedError } from "../../data/notes";
import { orderBy } from 'lodash';
import { canPerformAction } from "../../../../utils/actions";
import { useNotesEventTracker } from "../../utils/eventTracking";
import { RawHtml } from "../../../../components/RawHtml";
import { ChangeIntakeModal } from "../ChangeIntakeModal";
import { CancelApplicationModal } from '@applyboard/ab-application-legacy';
import { ChangeProgramModal } from "../ChangeProgramModal";
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { getInitials, getName } from "../../utils/names";
import { unstable_batchedUpdates } from 'react-dom';
import { NoteAvailableAction } from "../../../../types/Note";
import { ApplicationActionName } from "../../../../types";
import { Form, NoteFormProvider, useFieldValues, useGetFieldValues, useSetFieldValues, Field, useDraftNote, clearNoteDrafts, useDefaultNoteFormValues, useClearNoteForm } from "./NoteForm";
import { assert } from "../../../../utils/assert";
import { z } from 'zod';
import svgAbbieAvatar from "./abbieIcon.svg";
import { ErrorBoundary } from 'react-error-boundary';
import { GUTTER_WIDTH_TOKEN, MINI_HEADER_HEIGHT, GLOBAL_TOP_BAR_HEIGHT } from "../../consts";
import { WomanThinkingIllustration } from "../../../../illustrations";
import { IllustratedErrorState } from "../../../../components/IllustratedErrorState";
import { useNotesListContext } from "./NotesListProvider";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var LocationStateSchema = z.object({
  content: z.string(),
  subject: z.string(),
  noteTemplateNumber: z.string(),
  emailNotification: z["boolean"](),
  restricted: z["boolean"]()
});
var NOTE_BAR_HEIGHT = 80;
export function NotesList(props) {
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useParams = useParams(),
    application_id = _useParams.application_id;
  return _jsx(ErrorBoundary, {
    fallbackRender: function fallbackRender(_ref) {
      var error = _ref.error;
      return _jsx(IllustratedErrorState, {
        error: error,
        variant: "compact"
      });
    },
    onError: function onError(error) {
      clearNoteDrafts(application_id);
      trackEvent({
        event: 'Single Application V2 - Notes Tab - Displayed Error',
        error: error
      });
    },
    children: _jsx(NotesListComponent, _objectSpread({}, props))
  });
}
function NotesListComponent(_ref2) {
  var _noteToDelete$title;
  var currentCreatorPersona = _ref2.currentCreatorPersona,
    _ref2$showNotesTakeAc = _ref2.showNotesTakeActionMenu,
    showNotesTakeActionMenu = _ref2$showNotesTakeAc === void 0 ? false : _ref2$showNotesTakeAc,
    onStartLiveChat = _ref2.onStartLiveChat;
  var _useNotesListContext = useNotesListContext(),
    onPrefillTemplate = _useNotesListContext.onPrefillTemplate,
    noteType = _useNotesListContext.noteType,
    noteForm = _useNotesListContext.noteForm;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var isNewLayoutEnabled = !!application.newView;
  var headingId = useId();
  var _useNotes = useNotes(noteType === 'customer' ? 'application_customer_note' : 'application_admin_note'),
    applicationNotes = _useNotes.applicationNotes;
  var _useTranslation = useTranslation('NotesList'),
    t = _useTranslation.t;
  var toasts = useToasts();
  var _useDeleteNote = useDeleteNote(),
    deleteNote = _useDeleteNote.deleteNote,
    deleteNoteStatus = _useDeleteNote.deleteNoteStatus;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    noteToDelete = _useState2[0],
    setNoteToDelete = _useState2[1];
  var _useApplicationAvaila = useApplicationAvailableActions(),
    canPerformApplicationAction = _useApplicationAvaila.canPerformApplicationAction;
  var canCreate = canPerformApplicationAction(noteType === 'customer' ? ApplicationActionName.CREATE_CUSTOMER_NOTE : ApplicationActionName.CREATE_ADMIN_NOTE);
  return _jsx(NoteFormProvider, {
    currentCreatorPersona: currentCreatorPersona,
    children: _jsxs("section", {
      css: function css(theme) {
        return {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          paddingInline: isNewLayoutEnabled ? 0 : theme.spacing[4],
          marginTop: isNewLayoutEnabled ? "-".concat(theme.spacing[GUTTER_WIDTH_TOKEN]) : undefined
        };
      },
      "aria-labelledby": headingId,
      children: [_jsx("div", {
        ref: noteForm.refs.newNoteMarker,
        style: {
          scrollMarginTop: isNewLayoutEnabled ? "".concat(GLOBAL_TOP_BAR_HEIGHT + MINI_HEADER_HEIGHT, "px") : "".concat(GLOBAL_TOP_BAR_HEIGHT, "px")
        }
      }), _jsx(StickyBar, {
        top: isNewLayoutEnabled ? GLOBAL_TOP_BAR_HEIGHT + MINI_HEADER_HEIGHT : GLOBAL_TOP_BAR_HEIGHT,
        py: GUTTER_WIDTH_TOKEN,
        children: _jsxs(Flex, {
          direction: "row",
          align: "center",
          justify: "between",
          gap: 4,
          children: [_jsx(Flex.Item, {
            children: _jsx(Heading, {
              id: headingId,
              level: 2,
              variant: "titleL",
              children: t(noteType === 'customer' ? 'customerNotesTitle' : 'adminCommentsTitle')
            })
          }), showNotesTakeActionMenu ? _jsx(TakeActionMenu, {
            onStartLiveChat: onStartLiveChat,
            currentCreatorPersona: currentCreatorPersona
          }) : canCreate && _jsx(CreateNoteButton, {
            currentCreatorPersona: currentCreatorPersona
          })]
        })
      }), _jsxs(Flex, {
        direction: "column",
        gap: 6,
        pt: isNewLayoutEnabled ? 4 : 0,
        children: [_jsx(PrefillNewNoteFormFromHistory, {}), noteForm.isOpen && _jsx(NewNoteForm, {
          onPrefillTemplate: onPrefillTemplate,
          replyToId: noteForm.replyToId,
          currentCreatorPersona: currentCreatorPersona
        }), applicationNotes.length === 0 ? _jsx(EmptyStateView, {}) : _jsx(GridAlpha, {
          columns: "auto 1fr auto",
          columnGap: {
            xs: 3,
            sm: 4
          },
          rowGap: {
            xs: 4,
            sm: 6
          },
          children: orderBy(applicationNotes, function (note) {
            return new Date(note.createdAt);
          }, 'desc').map(function (note) {
            return _jsx(Note, {
              currentCreatorPersona: currentCreatorPersona,
              onShowDeleteDialog: function onShowDeleteDialog(noteId, noteTitle) {
                setNoteToDelete({
                  id: noteId,
                  title: noteTitle
                });
              },
              note: note
            }, note.id);
          })
        }), _jsx(DeleteNoteDialog, {
          open: !!noteToDelete,
          onOpenChange: function onOpenChange(open) {
            if (!open) setNoteToDelete(null);
          },
          onConfirmDelete: function onConfirmDelete() {
            if (!noteToDelete) return;
            deleteNote({
              noteId: noteToDelete.id
            }, {
              onSuccess: function onSuccess() {
                toasts.positive(t('successfullyDeletedNoteResolution'));
                setNoteToDelete(null);
              },
              onError: function onError(error) {
                if (error instanceof Error) {
                  toasts.negative(error);
                }
              }
            });
          },
          isDeleting: deleteNoteStatus === 'loading',
          noteTitle: (_noteToDelete$title = noteToDelete === null || noteToDelete === void 0 ? void 0 : noteToDelete.title) !== null && _noteToDelete$title !== void 0 ? _noteToDelete$title : ''
        })]
      })]
    })
  });
}
function CreateNoteButton(_ref3) {
  var currentCreatorPersona = _ref3.currentCreatorPersona;
  var _useTranslation2 = useTranslation('NotesList'),
    t = _useTranslation2.t;
  var _useNotesEventTracker = useNotesEventTracker(),
    trackEvent = _useNotesEventTracker.trackEvent;
  var _useDraftNote = useDraftNote({
      replyToId: undefined
    }),
    draftNote = _useDraftNote.draftNote;
  var setFieldValues = useSetFieldValues();
  var _useNotesListContext2 = useNotesListContext(),
    noteForm = _useNotesListContext2.noteForm;
  var clearNoteForm = useClearNoteForm(currentCreatorPersona);
  var showDraftIndicator = Boolean(draftNote && (!noteForm.isOpen || noteForm.replyToId));
  return _jsx(Badge, {
    "aria-label": "Abandoned draft",
    intent: "primary",
    size: "sm",
    enabled: showDraftIndicator,
    children: _jsx(Tooltip, {
      label: "Continue draft...",
      enabled: showDraftIndicator,
      children: _jsx(Button, {
        size: "sm",
        intent: "primary",
        leadIcon: PlusOutlineIcon,
        onClick: function onClick() {
          noteForm.open();
          if (draftNote) {
            setFieldValues(_objectSpread(_objectSpread({}, draftNote), {}, {
              parentNoteId: null
            }));
          } else if (!noteForm.isOpen || noteForm.replyToId) {
            clearNoteForm();
          }
          trackEvent({
            event: 'Clicked Primary CTA',
            data: {
              btnClicked: 'Create note'
            }
          });
        },
        ref: noteForm.refs.createButton,
        disabled: noteForm.createNoteStatus === 'loading',
        children: t('createNote')
      })
    })
  });
}
function TakeActionMenu(_ref4) {
  var onStartLiveChat = _ref4.onStartLiveChat,
    currentCreatorPersona = _ref4.currentCreatorPersona;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isActionMenuOpen = _useState4[0],
    setIsActionMenuOpen = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isChangeIntakeModalOpen = _useState6[0],
    setIsChangeIntakeModalOpen = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isCancelApplicationModalOpen = _useState8[0],
    setIsCancelApplicationModalOpen = _useState8[1];
  var _useCancelApplication = useCancelApplication(),
    cancelApplication = _useCancelApplication.cancelApplication,
    isCancellingApplication = _useCancelApplication.isCancellingApplication;
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isChangeProgramModalOpen = _useState10[0],
    setIsChangeProgramModalOpen = _useState10[1];
  var openFormButtonRef = useRef(null);
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var _useApplicationAvaila2 = useApplicationAvailableActions(),
    canPerformApplicationAction = _useApplicationAvaila2.canPerformApplicationAction;
  var canChangeIntake = canPerformApplicationAction(ApplicationActionName.CHANGE_INTAKE);
  var canChangeProgram = canPerformApplicationAction(ApplicationActionName.CHANGE_PROGRAM);
  var canCancelApplication = canPerformApplicationAction(ApplicationActionName.CANCEL);
  var hasSelfServeAction = canChangeIntake || canChangeProgram || canCancelApplication;
  var _useTranslation3 = useTranslation('NotesList'),
    t = _useTranslation3.t;
  var _useNotesEventTracker2 = useNotesEventTracker(),
    trackEvent = _useNotesEventTracker2.trackEvent;
  var actionDropdownEvent = 'Clicked Item From Take Action Dropdown';
  var _useDraftNote2 = useDraftNote({
      replyToId: undefined
    }),
    draftNote = _useDraftNote2.draftNote;
  var setFieldValues = useSetFieldValues();
  var clearNoteForm = useClearNoteForm(currentCreatorPersona);
  var _useNotesListContext3 = useNotesListContext(),
    noteForm = _useNotesListContext3.noteForm;
  var showDraftIndicator = Boolean(draftNote && (!noteForm.isOpen || noteForm.replyToId));
  return _jsxs(_Fragment, {
    children: [_jsxs(MenuButton, {
      open: isActionMenuOpen,
      onOpenChange: function onOpenChange(open) {
        setIsActionMenuOpen(open);
        if (open) {
          trackEvent({
            event: 'Clicked Primary CTA',
            data: {
              btnClicked: 'Take action'
            }
          });
        }
      },
      alignment: "right",
      children: [_jsx(MenuButton.Trigger, {
        children: _jsx(Button, {
          intent: "primary",
          size: "sm",
          onClick: function onClick() {
            return setIsActionMenuOpen(true);
          },
          ref: openFormButtonRef,
          children: t('takeAction')
        })
      }), hasSelfServeAction && _jsx(MenuButton.Header, {
        children: _jsx(Text, {
          variant: "labelM",
          children: t('selfServeActions')
        })
      }), canChangeIntake && _jsx(MenuButton.Button, {
        id: "takeActionChangeIntake",
        onClick: function onClick() {
          setIsChangeIntakeModalOpen(true);
          trackEvent({
            event: actionDropdownEvent,
            data: {
              itemSelected: 'Change intake'
            }
          });
        },
        children: t('changeIntake')
      }), canChangeProgram && _jsx(MenuButton.Button, {
        id: "takeActionChangeProgram",
        onClick: function onClick() {
          setIsChangeProgramModalOpen(true);
          trackEvent({
            event: actionDropdownEvent,
            data: {
              itemSelected: 'Change program'
            }
          });
        },
        children: t('changeProgram')
      }), canCancelApplication && _jsx(MenuButton.Button, {
        id: "takeActionCancelApplication",
        onClick: function onClick() {
          setIsCancelApplicationModalOpen(true);
          trackEvent({
            event: actionDropdownEvent,
            data: {
              itemSelected: 'Cancel application'
            }
          });
        },
        children: t('cancelApplication')
      }), hasSelfServeAction && _jsx(MenuButton.Divider, {}), _jsx(MenuButton.Tooltip, {
        label: t('continueDraftNote'),
        enabled: showDraftIndicator,
        placement: "left",
        children: _jsx(MenuButton.Button, {
          id: "takeActionCreateNote",
          onClick: function onClick() {
            noteForm.open();
            if (draftNote) {
              setFieldValues(_objectSpread(_objectSpread({}, draftNote), {}, {
                parentNoteId: null
              }));
            } else if (!noteForm.isOpen || noteForm.replyToId) {
              clearNoteForm();
            }
            trackEvent({
              event: actionDropdownEvent,
              data: {
                itemSelected: 'Create note'
              }
            });
          },
          children: _jsxs(Flex, {
            align: "center",
            gap: 2,
            children: [t('createNote'), showDraftIndicator && _jsx("div", {
              css: function css(theme) {
                return {
                  width: '8px',
                  height: '8px',
                  backgroundColor: theme.colors.actionPrimary,
                  borderRadius: '99999px'
                };
              }
            })]
          })
        })
      }), _jsx(MenuButton.Button, {
        id: "takeActionStartLiveChat",
        onClick: function onClick() {
          onStartLiveChat === null || onStartLiveChat === void 0 ? void 0 : onStartLiveChat();
          trackEvent({
            event: actionDropdownEvent,
            data: {
              itemSelected: 'Start Live Chat'
            }
          });
        },
        children: t('startLiveChat')
      })]
    }), _jsx(ChangeIntakeModal, {
      hideDialogTrigger: true,
      isOpenViaProp: isChangeIntakeModalOpen,
      onOpenChange: setIsChangeIntakeModalOpen,
      origin: "self serve"
    }), _jsx(ChangeProgramModal, {
      isOpen: isChangeProgramModalOpen,
      onOpenChange: setIsChangeProgramModalOpen,
      onSuccess: function onSuccess() {
        return setIsChangeProgramModalOpen(false);
      }
    }), _jsx(CancelApplicationModal, {
      open: isCancelApplicationModalOpen,
      onClose: function onClose() {
        setIsCancelApplicationModalOpen(false);
      },
      applicationId: legacyApplication.id,
      cancelApplication: cancelApplication,
      isCancellingApplication: isCancellingApplication
    })]
  });
}
function PrefillNewNoteFormFromHistory() {
  var _useLocation = useLocation(),
    hash = _useLocation.hash,
    state = _useLocation.state;
  var history = useHistory();
  var setFieldValues = useSetFieldValues();
  var _useNotesListContext4 = useNotesListContext(),
    noteForm = _useNotesListContext4.noteForm;

  // eslint-disable-next-line no-restricted-syntax -- we need an effect to open the new note form
  useEffect(function () {
    if (hash === '#new' && state) {
      var result = LocationStateSchema.safeParse(state);
      if (result.success) {
        noteForm.open();
        setFieldValues(_objectSpread(_objectSpread({}, result.data), {}, {
          parentNoteId: null
        }));
      }
      history.replace("".concat(location.pathname).concat(location.search));
    }
  }, [hash, state, noteForm, setFieldValues, history]);
  return null;
}
function NewNoteForm(_ref5) {
  var _createAction$additio, _createAction$additio2, _createAction$additio3, _createAction$additio4, _createAction$additio5;
  var onPrefillTemplate = _ref5.onPrefillTemplate,
    replyToId = _ref5.replyToId,
    currentCreatorPersona = _ref5.currentCreatorPersona;
  var _useNotesListContext5 = useNotesListContext(),
    noteForm = _useNotesListContext5.noteForm,
    noteType = _useNotesListContext5.noteType;
  var formId = useId();
  var _useTranslation4 = useTranslation('NotesList'),
    t = _useTranslation4.t;
  var _useNotesEventTracker3 = useNotesEventTracker(),
    trackEvent = _useNotesEventTracker3.trackEvent;
  var _useApplicationAvaila3 = useApplicationAvailableActions(),
    getApplicationAvailableAction = _useApplicationAvaila3.getApplicationAvailableAction;
  var createAction = getApplicationAvailableAction(noteType === 'customer' ? ApplicationActionName.CREATE_CUSTOMER_NOTE : ApplicationActionName.CREATE_ADMIN_NOTE);
  var isFormDisabled = noteForm.createNoteStatus === 'loading';
  var isAdminAction = (createAction === null || createAction === void 0 ? void 0 : createAction.id) === ApplicationActionName.CREATE_ADMIN_NOTE;
  var prefillFromTemplateAllowed = isAdminAction || (createAction === null || createAction === void 0 ? void 0 : (_createAction$additio = createAction.additionalInformation) === null || _createAction$additio === void 0 ? void 0 : _createAction$additio.prefillFromTemplateAllowed);
  var editorPowerFeaturesAllowed = isAdminAction || (createAction === null || createAction === void 0 ? void 0 : (_createAction$additio2 = createAction.additionalInformation) === null || _createAction$additio2 === void 0 ? void 0 : _createAction$additio2.editorPowerFeaturesAllowed);
  var emailRpAllowed = !isAdminAction && (createAction === null || createAction === void 0 ? void 0 : (_createAction$additio3 = createAction.additionalInformation) === null || _createAction$additio3 === void 0 ? void 0 : _createAction$additio3.emailRpAllowed);
  var _useDraftNote3 = useDraftNote({
      replyToId: replyToId
    }),
    setDraftNote = _useDraftNote3.setDraftNote;
  var clearNoteForm = useClearNoteForm(currentCreatorPersona);
  return _jsx(Form, {
    id: formId,
    children: _jsx(Card, {
      emphasis: "highlighted",
      children: _jsxs(Flex, {
        direction: "column",
        gap: 3,
        px: 2,
        children: [noteForm.createNoteStatus === 'error' && _jsx(NoteErrorNotice, {
          error: noteForm.createNoteError
        }), _jsxs(Flex, {
          justify: "between",
          align: "center",
          children: [_jsxs(Flex, {
            gap: 2,
            children: [prefillFromTemplateAllowed && _jsx(PrefillTemplateButton, {
              disabled: isFormDisabled,
              onPrefillTemplate: onPrefillTemplate
            }), (createAction === null || createAction === void 0 ? void 0 : (_createAction$additio4 = createAction.additionalInformation) === null || _createAction$additio4 === void 0 ? void 0 : _createAction$additio4.attachDocumentAllowed) && _jsx(AttachmentsDialog, {
              openDialogButtonDisabled: isFormDisabled
            })]
          }), !isAdminAction && (createAction === null || createAction === void 0 ? void 0 : (_createAction$additio5 = createAction.additionalInformation) === null || _createAction$additio5 === void 0 ? void 0 : _createAction$additio5.createPrivateAllowed) && _jsxs(Flex, {
            gap: 2,
            align: "center",
            children: [_jsx(Field, {
              disabled: isFormDisabled,
              label: t('privateNoteLabel'),
              name: "restricted",
              as: Checkbox,
              onChange: function onChange() {
                trackEvent({
                  event: 'Clicked Private Note'
                });
              }
            }), _jsx(Tooltip, {
              label: t('privateNoteTooltip'),
              children: _jsx(Tooltip.Icon, {
                emphasis: "highlighted",
                intent: "secondary"
              })
            })]
          })]
        }), _jsx(Flex.Item, {
          children: _jsx(Field, {
            disabled: isFormDisabled,
            as: TextInput,
            label: t('titleInputLabel'),
            size: "lg",
            type: "text",
            name: "subject",
            required: t('titleInputRequiredMessage')
          })
        }), _jsx(Flex.Item, {
          children: _jsx(Field, {
            disabled: isFormDisabled,
            as: RichTextEditor,
            label: t('contentInputLabel'),
            name: "content",
            required: t('contentInputRequiredMessage'),
            validate: validateMarkdownAccessibility,
            powerFeatures: editorPowerFeaturesAllowed ? ['alerts', ['headings', {
              maxLevel: 1,
              styles: {
                h1: {
                  variant: 'bodyM',
                  contrast: 'mid',
                  bold: true
                }
              }
            }]] : undefined
          })
        }), _jsx(FileListWrapper, {}), _jsxs(Flex, {
          align: "center",
          justify: emailRpAllowed ? 'between' : 'end',
          children: [emailRpAllowed && _jsx(Flex.Item, {
            children: _jsx(Field, {
              disabled: isFormDisabled,
              as: Checkbox,
              label: t('emailRecruitmentPartner'),
              name: "emailNotification",
              onChange: function onChange() {
                trackEvent({
                  event: 'Clicked Email Recruitment Partner'
                });
              }
            })
          }), _jsxs(Flex, {
            gap: 2,
            children: [_jsx(Button, {
              disabled: isFormDisabled,
              onClick: function onClick() {
                setDraftNote(null);
                trackEvent({
                  event: 'Clicked Cancel'
                });
                clearNoteForm();
                noteForm.close();
              },
              emphasis: "transparent",
              intent: "primary",
              size: "sm",
              children: t('cancel')
            }), _jsx(Button, {
              loading: isFormDisabled,
              type: "submit",
              form: formId,
              intent: "primary",
              size: "sm",
              onClick: function onClick() {
                trackEvent({
                  event: 'Clicked Send'
                });
              },
              children: t('send')
            })]
          })]
        })]
      })
    })
  });
}
function PrefillTemplateButton(_ref6) {
  var onPrefillTemplate = _ref6.onPrefillTemplate,
    disabled = _ref6.disabled;
  var _useNotesEventTracker4 = useNotesEventTracker(),
    trackEvent = _useNotesEventTracker4.trackEvent;
  var setFormValues = useSetFieldValues();
  var _useTranslation5 = useTranslation('NotesList'),
    t = _useTranslation5.t;
  var toasts = useToasts();
  var getValue = useGetFieldValues();
  return _jsx(Button, {
    disabled: disabled,
    emphasis: "outlined",
    intent: "primary",
    leadIcon: MagicWandOutlineIcon,
    size: "sm",
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var formValues, _template$email_user, _template$restricted, result, renderedTemplate, template;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            trackEvent({
              event: 'Clicked To Pre-Fill With Template'
            });
            formValues = getValue();
            _context.prev = 2;
            _context.next = 5;
            return onPrefillTemplate(formValues.restricted, trackEvent);
          case 5:
            result = _context.sent;
            if (result) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return");
          case 8:
            renderedTemplate = result.renderedTemplate, template = result.template;
            setFormValues({
              subject: template.note_title || '',
              content: renderedTemplate || '',
              noteTemplateNumber: template.id,
              emailNotification: (_template$email_user = template.email_user) !== null && _template$email_user !== void 0 ? _template$email_user : false,
              restricted: (_template$restricted = template.restricted) !== null && _template$restricted !== void 0 ? _template$restricted : false
            });
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            toasts.negative(new Error(t('errorPrefillingTemplate')));
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 12]]);
    })),
    children: t('prefillTemplateButtonLabel')
  });
}
function Note(_ref8) {
  var currentCreatorPersona = _ref8.currentCreatorPersona,
    _onShowDeleteDialog = _ref8.onShowDeleteDialog,
    note = _ref8.note;
  var noteId = note.id,
    availableActions = note.availableActions;
  var _useNote = useNote(noteId),
    applicationNote = _useNote.applicationNote;
  var _useLocation2 = useLocation(),
    hash = _useLocation2.hash;
  var noteRef = useRef(null);
  var didScrollToNote = useRef(false);

  // eslint-disable-next-line no-restricted-syntax -- we need an effect to scroll the selected note into view
  useEffect(function () {
    if (!didScrollToNote.current && noteRef.current && "#".concat(noteId) === hash) {
      noteRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
      didScrollToNote.current = true;
    }
  }, [noteId, hash]);
  useMarkNoteReadWhenViewed({
    availableActions: availableActions,
    noteId: noteId,
    noteRef: noteRef
  });
  var _useNoteUser = useNoteUser(applicationNote.legacyCreatorId),
    noteUser = _useNoteUser.noteUser;
  assert(noteUser, "Note user not found for id ".concat(applicationNote.legacyCreatorId));
  var firstName = noteUser.firstName;
  var lastName = noteUser.lastName;
  var isAiGenerated = applicationNote.creatorPersona === 'applyboard_automation';
  var _useApplication2 = useApplication(),
    application = _useApplication2.application;
  var isNewLayoutEnabled = !!application.newView;
  var noteMatchesCurrentPersona = currentCreatorPersona === 'applicant' || currentCreatorPersona === 'rp' ? applicationNote.creatorPersona === 'applicant' || applicationNote.creatorPersona === 'rp_staff' || applicationNote.creatorPersona === 'rp_owner' : applicationNote.creatorPersona === 'applyboard_automation' || applicationNote.creatorPersona === 'applyboard_support_team';
  var avatar = _jsx(Avatar, {
    alt: isAiGenerated ? 'Abbie Logo' : undefined,
    initials: isAiGenerated ? undefined : getInitials(firstName, lastName),
    intent: noteMatchesCurrentPersona ? 'positive' : 'magic',
    image: isAiGenerated ? svgAbbieAvatar : undefined,
    size: {
      xs: 'xs',
      sm: 'md'
    }
  });
  return _jsxs(_Fragment, {
    children: [_jsx(GridAlpha.Item, {
      children: !noteMatchesCurrentPersona && avatar
    }), _jsx(GridAlpha.Item, {
      children: _jsx("div", {
        ref: noteRef,
        style: {
          scrollMarginTop: isNewLayoutEnabled ? "".concat(GLOBAL_TOP_BAR_HEIGHT + MINI_HEADER_HEIGHT + NOTE_BAR_HEIGHT, "px") : "".concat(GLOBAL_TOP_BAR_HEIGHT + NOTE_BAR_HEIGHT, "px")
        },
        children: _jsxs(Flex, {
          direction: "column",
          gap: 3,
          children: [_jsx(Flex.Item, {
            align: noteMatchesCurrentPersona ? 'end' : 'start',
            children: _jsx(Text, {
              variant: "labelL",
              children: isAiGenerated ? _jsxs(Flex, {
                gap: 2,
                children: [_jsx("span", {
                  children: "Abbie"
                }), _jsx(Tag, {
                  intent: "magic",
                  children: "AI"
                })]
              }) : getName(firstName, lastName)
            })
          }), _jsx(NoteCard, {
            noteId: noteId,
            onShowDeleteDialog: function onShowDeleteDialog() {
              var _applicationNote$subj;
              return _onShowDeleteDialog(noteId, (_applicationNote$subj = applicationNote === null || applicationNote === void 0 ? void 0 : applicationNote.subject) !== null && _applicationNote$subj !== void 0 ? _applicationNote$subj : '');
            }
          })]
        })
      })
    }), _jsx(GridAlpha.Item, {
      children: noteMatchesCurrentPersona && avatar
    })]
  });
}
function useMarkNoteReadWhenViewed(_ref9) {
  var availableActions = _ref9.availableActions,
    noteId = _ref9.noteId,
    noteRef = _ref9.noteRef;
  var _useUpdateNote = useUpdateNote(),
    updateApplicationNote = _useUpdateNote.updateApplicationNote;

  // eslint-disable-next-line no-restricted-syntax -- using intersection observer to determine note has been read
  useEffect(function () {
    if (!noteRef.current || !(availableActions !== null && availableActions !== void 0 && availableActions.some(function (action) {
      return action.id === 'read';
    }))) return;
    var observer = new IntersectionObserver(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 1),
        entry = _ref11[0];
      if (entry.isIntersecting) {
        updateApplicationNote({
          noteId: noteId,
          read: true
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.5
    });
    observer.observe(noteRef.current);
    return function () {
      return observer.disconnect();
    };
  }, [noteId, updateApplicationNote, availableActions, noteRef]);
}
export var NoteErrorNotice = function NoteErrorNotice(_ref12) {
  var error = _ref12.error;
  var _useTranslation6 = useTranslation('NotesList'),
    t = _useTranslation6.t;
  return _jsx(Notice, {
    intent: "negative",
    width: "fill",
    children: error && isNoteContentCreationFailedError(error) ? t('noteContentCreationFailed') : t('errorOnNoteAction')
  });
};
var NoteCard = function NoteCard(_ref13) {
  var _applicationNote$read, _applicationNote$read2, _applicationNote$cont, _applicationNote$cont2;
  var noteId = _ref13.noteId,
    onShowDeleteDialog = _ref13.onShowDeleteDialog;
  var cardStyle = useCardStyle(noteId);
  var headingId = useId();
  var toasts = useToasts();
  var _useNote2 = useNote(noteId),
    applicationNote = _useNote2.applicationNote;
  var _useUpdateNote2 = useUpdateNote(),
    updateApplicationNote = _useUpdateNote2.updateApplicationNote,
    updateApplicationNoteStatus = _useUpdateNote2.updateApplicationNoteStatus;
  var _useAcceptAbbieNote = useAcceptAbbieNote(),
    acceptAbbieNote = _useAcceptAbbieNote.acceptAbbieNote,
    acceptAbbieNoteStatus = _useAcceptAbbieNote.acceptAbbieNoteStatus;
  var _useDeleteNote2 = useDeleteNote(),
    deleteNoteStatus = _useDeleteNote2.deleteNoteStatus;
  var _useTranslation7 = useTranslation('NotesList'),
    t = _useTranslation7.t;
  var _useNotesEventTracker5 = useNotesEventTracker(),
    trackEvent = _useNotesEventTracker5.trackEvent;
  var _useNoteUser2 = useNoteUser((_applicationNote$read = applicationNote.readConfirmation) === null || _applicationNote$read === void 0 ? void 0 : _applicationNote$read.readByLegacyId),
    noteUser = _useNoteUser2.noteUser;
  var readReceiptString = useReadReceiptString({
    readConfirmation: (_applicationNote$read2 = applicationNote.readConfirmation) !== null && _applicationNote$read2 !== void 0 ? _applicationNote$read2 : undefined,
    readByUser: noteUser !== null && noteUser !== void 0 ? noteUser : undefined
  });
  var canResolve = canPerformAction(applicationNote, NoteAvailableAction.RESOLVE);
  var resolveSwitch = canResolve && applicationNote.flags.resolved != null && _jsxs(Flex, {
    direction: "row",
    gap: 4,
    children: [_jsx(Text, {
      variant: "labelM",
      children: t('resolved')
    }), _jsx(Switch, {
      label: applicationNote.flags.resolved ? t('yes') : t('no'),
      onChange: function onChange(value) {
        updateApplicationNote({
          noteId: noteId,
          resolved: value
        }, {
          onSuccess: function onSuccess() {
            toasts.positive(t('successfullyUpdatedNoteResolution'));
          }
        });
        trackEvent({
          event: 'Clicked To Toggle Resolve',
          data: {
            toggleStatus: value
          }
        });
      },
      labelPlacement: "right",
      disabled: updateApplicationNoteStatus === 'loading',
      value: applicationNote.flags.resolved
    })]
  });
  var buttons = _jsx(NoteCardActions, {
    note: applicationNote,
    onShowDeleteDialog: onShowDeleteDialog
  });
  var isAiGenerated = applicationNote.creatorPersona === 'applyboard_automation';
  var updateNoteFromAiButtons = function updateNoteFromAiButtons(isSatisfied) {
    trackEvent({
      event: isSatisfied ? 'AI - Clicked Yes Button' : 'AI - Clicked No Button'
    });
    if (isSatisfied) {
      assert(applicationNote.parentNoteId, "parentNoteId is not in applicationNote for ID: ".concat(noteId));
      acceptAbbieNote({
        noteId: noteId,
        parentNoteId: applicationNote.parentNoteId
      });
    } else {
      updateApplicationNote({
        noteId: noteId,
        acceptedByApplicant: isSatisfied
      });
    }
  };
  return _jsxs(Card, {
    "aria-labelledby": headingId,
    intent: cardStyle.intent,
    children: [_jsxs(Flex, {
      gap: 4,
      direction: "column",
      children: [_jsxs(Flex, {
        gap: 2,
        direction: "column",
        children: [(acceptAbbieNoteStatus === 'error' || updateApplicationNoteStatus === 'error' || deleteNoteStatus === 'error') && _jsx(NoteErrorNotice, {}), _jsxs(Flex, {
          align: "start",
          justify: "between",
          gap: 2,
          wrap: true,
          children: [_jsx(Text, {
            id: headingId,
            variant: "titleM",
            wordBreak: "word",
            children: applicationNote.subject
          }), _jsx(Text, {
            variant: "bodyS",
            overflow: "nowrap",
            children: formatTimestamp(new Date(applicationNote.createdAt).toISOString())
          })]
        }), _jsx(ErrorBoundary, {
          fallback: _jsx(Notice, {
            intent: "negative",
            children: isAiGenerated ? t('contentRenderErrorAbbie') : t('contentRenderError')
          }),
          onError: function onError(error) {
            return trackEvent({
              event: 'Note Body - Displayed Error',
              error: error
            });
          },
          children: _jsx(Text, {
            variant: "bodyM",
            children: applicationNote.contentEncoding === 'markdown' ? _jsx(Markdown, {
              markdown: (_applicationNote$cont = applicationNote.content) !== null && _applicationNote$cont !== void 0 ? _applicationNote$cont : '',
              headingSettings: {
                baseLevel: 3,
                styles: {
                  h1: {
                    variant: 'bodyM',
                    contrast: 'mid',
                    bold: true
                  }
                }
              }
            }) : _jsx(RawHtml, {
              dangerouslySetInnerHTML: {
                __html: (_applicationNote$cont2 = applicationNote.content) !== null && _applicationNote$cont2 !== void 0 ? _applicationNote$cont2 : ''
              }
            })
          })
        }), applicationNote.attachments.length > 0 && _jsx(Flex, {
          align: "start",
          direction: "column",
          children: applicationNote.attachments.map(function (attachment) {
            return _jsx(Link, {
              leadIcon: DocumentCheckOutlineIcon,
              href: attachment.fileDownloadLink,
              mode: "override_user_choice_and_open_in_new_tab",
              variant: "standalone",
              onClick: function onClick() {
                trackEvent({
                  event: 'Clicked To View Attached Document'
                });
              },
              children: attachment.fileName
            }, attachment.id);
          })
        }), _jsxs(Flex, {
          gap: 2,
          children: [applicationNote.flags.emailNotification && _jsx(Tag, {
            intent: "secondary",
            children: t('emailNotificationTag')
          }), applicationNote.flags.restricted && _jsx(Tag, {
            intent: "secondary",
            children: t('privateTag')
          })]
        })]
      }), _jsx(Flex, {
        gap: 2,
        direction: "column",
        children: resolveSwitch && readReceiptString ? _jsxs(_Fragment, {
          children: [_jsxs(Flex, {
            align: "center",
            justify: "between",
            children: [resolveSwitch, buttons]
          }), _jsx(Text, {
            intent: "secondary",
            contrast: "mid",
            variant: "bodyS",
            children: readReceiptString
          })]
        }) : resolveSwitch ? _jsxs(Flex, {
          align: "center",
          justify: "between",
          children: [resolveSwitch, buttons]
        }) : readReceiptString ? _jsxs(Flex, {
          align: "center",
          justify: "between",
          children: [_jsx(Text, {
            intent: "secondary",
            contrast: "mid",
            variant: "bodyS",
            children: readReceiptString
          }), buttons]
        }) : _jsx(Flex, {
          justify: "end",
          children: buttons
        })
      })]
    }), isAiGenerated && applicationNote.acceptedByAutomation !== false && _jsx(Card.Footer, {
      emphasis: "highlighted",
      children: _jsx(Box, {
        p: 2,
        children: applicationNote.acceptedByApplicant === true ? _jsxs(Flex, {
          gap: 4,
          children: [_jsx(CheckMarkOutlineIcon, {
            intent: "positive"
          }), _jsx(Text, {
            children: t('ai.resolvedText')
          })]
        }) : applicationNote.acceptedByApplicant === false ? _jsx(_Fragment, {
          children: _jsx(Text, {
            contrast: "mid",
            variant: "bodyS",
            children: t('ai.followupText')
          })
        }) : _jsxs(Flex, {
          align: "center",
          children: [_jsxs(Flex, {
            align: "center",
            gap: 2,
            children: [_jsx(Text, {
              children: t('ai.text')
            }), _jsx(Tooltip, {
              label: t('ai.tooltip'),
              children: _jsx(Tooltip.Icon, {})
            })]
          }), _jsx(Button, {
            disabled: updateApplicationNoteStatus === 'loading' || acceptAbbieNoteStatus === 'loading',
            emphasis: "transparent",
            intent: "secondary",
            leadIcon: ThumbUpOutlineIcon,
            ml: 4,
            onClick: function onClick() {
              return updateNoteFromAiButtons(true);
            },
            size: "sm",
            children: t('ai.buttonApprove')
          }), _jsx(Button, {
            disabled: updateApplicationNoteStatus === 'loading',
            emphasis: "transparent",
            intent: "secondary",
            leadIcon: ThumbDownOutlineIcon,
            onClick: function onClick() {
              return updateNoteFromAiButtons(false);
            },
            size: "sm",
            children: t('ai.buttonReject')
          })]
        })
      })
    })]
  });
};
function AttachmentsDialog(_ref14) {
  var openDialogButtonDisabled = _ref14.openDialogButtonDisabled;
  var _useTranslation8 = useTranslation('NotesList'),
    t = _useTranslation8.t;
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isOpen = _useState12[0],
    setIsOpen = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    value = _useState14[0],
    setValue = _useState14[1];
  var setFormValues = useSetFieldValues();
  var getFieldValues = useGetFieldValues();
  var _useUploadAttachment = useUploadAttachment(),
    uploadAttachmentAsync = _useUploadAttachment.uploadAttachmentAsync,
    uploadAttachmentStatus = _useUploadAttachment.uploadAttachmentStatus;
  var toasts = useToasts();
  var _useNotesEventTracker6 = useNotesEventTracker(),
    trackEvent = _useNotesEventTracker6.trackEvent;
  var showAttachmentError = value.some(function (file) {
    return file === null || file === void 0 ? void 0 : file.errorMessage;
  });
  return _jsxs(Dialog, {
    open: isOpen,
    size: "md",
    onOpenChange: function onOpenChange(newOpen) {
      if (!newOpen) {
        setValue([]);
      }
      setIsOpen(newOpen);
    },
    children: [_jsx(Dialog.Trigger, {
      children: _jsx(Button, {
        disabled: openDialogButtonDisabled,
        emphasis: "outlined",
        intent: "primary",
        leadIcon: AttachFileOutlineIcon,
        size: "sm",
        onClick: function onClick() {
          trackEvent({
            event: 'Clicked To Attach Document'
          });
        },
        children: t('attachDocumentButtonLabel')
      })
    }), _jsx(Dialog.Heading, {
      children: t('attachmentDialogTitle')
    }), _jsx(Dialog.Content, {
      children: _jsx(FileUpload, {
        label: t('attachmentDialogLabel'),
        maxNumberOfFiles: 10,
        multiple: true,
        onChange: setValue,
        invalid: showAttachmentError,
        uploadFile: function uploadFile(file, _ref15) {
          var onSuccess = _ref15.onSuccess,
            onError = _ref15.onError;
          uploadAttachmentAsync({
            attachment: file
          }).then(function (fileId) {
            onSuccess(fileId);
          })["catch"](function (error) {
            if (error instanceof Error) {
              toasts.negative(error);
            }
            onError();
          });
        },
        value: value,
        helpText: t(showAttachmentError ? 'attachmentDialogError' : 'attachmentDialogHelpText'),
        allowedFileTypes: ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.gif', '.bin']
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: t('cancel')
      }), _jsx(Button, {
        intent: "primary",
        width: "fill",
        loading: uploadAttachmentStatus === 'loading',
        disabled: value.length === 0 || showAttachmentError,
        onClick: function onClick() {
          unstable_batchedUpdates(function () {
            var _getFieldValues$attac;
            var existingAttachments = (_getFieldValues$attac = getFieldValues().attachments) !== null && _getFieldValues$attac !== void 0 ? _getFieldValues$attac : [];
            setValue([]);
            setFormValues({
              attachments: [].concat(_toConsumableArray(existingAttachments), _toConsumableArray(value))
            });
            setIsOpen(false);
          });
        },
        children: t('attachDocumentButtonLabel')
      })]
    })]
  });
}
function FileListWrapper() {
  var _useTranslation9 = useTranslation('NotesList'),
    t = _useTranslation9.t;
  var fieldValues = useFieldValues();
  var setFieldValues = useSetFieldValues();
  var attachments = fieldValues.attachments;
  if (attachments.length === 0) {
    return null;
  }
  return _jsxs(Flex, {
    direction: "column",
    children: [_jsx(FileList, {
      label: "Attachments",
      size: "md",
      orientation: "horizontal",
      maxItems: 3,
      children: attachments.map(function (f) {
        return _jsx(FileList.Item, {
          name: f.file.name,
          onRemove: function onRemove(id) {
            setFieldValues({
              attachments: attachments.filter(function (f) {
                return f.id !== id;
              })
            });
          },
          value: f.id
        }, f.id);
      })
    }), attachments.length > 10 && _jsx(HelpText, {
      showIcon: true,
      intent: "negative",
      children: t('attachmentLimitExceededError')
    })]
  });
}
function NoteCardActions(_ref16) {
  var onShowDeleteDialog = _ref16.onShowDeleteDialog,
    note = _ref16.note;
  var _useNotesListContext6 = useNotesListContext(),
    noteForm = _useNotesListContext6.noteForm,
    noteType = _useNotesListContext6.noteType;
  var _useTranslation10 = useTranslation('NotesList'),
    t = _useTranslation10.t;
  var _useNotesEventTracker7 = useNotesEventTracker(),
    trackEvent = _useNotesEventTracker7.trackEvent;
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isMenuOpen = _useState16[0],
    setMenuOpen = _useState16[1];
  var canDelete = canPerformAction(note, NoteAvailableAction.DELETE);
  var _useApplication3 = useApplication(),
    application = _useApplication3.application;
  var noteUrl = useNoteUrl(note.id, noteType, application.legacyId);
  var toast = useToasts();
  var _useApplicationAvaila4 = useApplicationAvailableActions(),
    canPerformApplicationAction = _useApplicationAvaila4.canPerformApplicationAction;
  var canCreate = canPerformApplicationAction(noteType === 'customer' ? ApplicationActionName.CREATE_CUSTOMER_NOTE : ApplicationActionName.CREATE_ADMIN_NOTE);
  var _useDraftNote4 = useDraftNote({
      replyToId: note.id
    }),
    draftNote = _useDraftNote4.draftNote;
  var showDraftIndicator = Boolean(draftNote && noteForm.replyToId !== note.id);
  var defaultNoteFormValues = useDefaultNoteFormValues(note.creatorPersona);
  var setFieldValues = useSetFieldValues();
  return _jsxs(Flex, {
    direction: "row",
    gap: 2,
    children: [canCreate && _jsx(Badge, {
      "aria-label": "Abandoned draft",
      intent: "primary",
      size: "sm",
      enabled: showDraftIndicator,
      children: _jsx(Tooltip, {
        label: "Continue draft...",
        enabled: showDraftIndicator,
        children: _jsx(Button, {
          size: "sm",
          leadIcon: ReplyOutlineIcon,
          emphasis: "highlighted",
          intent: "primary",
          onClick: function onClick() {
            var _note$parentNoteId, _note$flags$restricte;
            noteForm.open({
              replyToId: note.id
            });
            var parentNoteId = (_note$parentNoteId = note.parentNoteId) !== null && _note$parentNoteId !== void 0 ? _note$parentNoteId : note.id;
            setFieldValues(draftNote ? _objectSpread(_objectSpread({}, draftNote), {}, {
              parentNoteId: parentNoteId
            }) : _objectSpread(_objectSpread({}, defaultNoteFormValues), {}, {
              parentNoteId: parentNoteId,
              subject: note.subject ? "".concat(t('replyPrefix'), ": ").concat(note.subject) : '',
              restricted: (_note$flags$restricte = note.flags.restricted) !== null && _note$flags$restricte !== void 0 ? _note$flags$restricte : false
            }));
            trackEvent({
              event: 'Clicked To Reply To Note'
            });
          },
          disabled: noteForm.createNoteStatus === 'loading',
          children: t('reply')
        })
      })
    }), _jsxs(MenuButton, {
      open: isMenuOpen,
      onOpenChange: setMenuOpen,
      children: [_jsx(MenuButton.Trigger, {
        children: _jsx(Button, {
          leadIcon: MoreVertOutlineIcon,
          emphasis: "highlighted",
          intent: "primary",
          size: "sm",
          "aria-label": t('moreOptions'),
          onClick: function onClick() {
            return setMenuOpen(true);
          }
        })
      }), _jsx(MenuButton.Button, {
        icon: CopyOutlineIcon,
        id: "copy-note-link",
        onClick: function onClick() {
          navigator.clipboard.writeText(noteUrl).then(function () {
            toast.positive(t('copiedNoteLinkToClipboard'));
          });
          trackEvent({
            event: 'Clicked Item From Three Dot Menu',
            data: {
              itemSelected: t('copyNoteLink')
            }
          });
        },
        children: t('copyNoteLink')
      }), canDelete && _jsx(MenuButton.Button, {
        icon: DeleteOutlineIcon,
        id: "delete-note",
        onClick: function onClick() {
          onShowDeleteDialog();
          trackEvent({
            event: 'Clicked Item From Three Dot Menu',
            data: {
              itemSelected: t('deleteNote')
            }
          });
        },
        children: t('deleteNote')
      })]
    })]
  });
}
function useNoteUrl(noteId, noteType, legacyApplicationId) {
  var tabParameter = noteType === 'customer' ? 'notes' : 'admin-comments';
  return "".concat(window.location.origin, "/applications/").concat(legacyApplicationId, "/").concat(tabParameter, "#").concat(noteId);
}
function useReadReceiptString(_ref17) {
  var readConfirmation = _ref17.readConfirmation,
    readByUser = _ref17.readByUser;
  var _useTranslation11 = useTranslation('NotesList'),
    t = _useTranslation11.t;
  if (!readConfirmation) {
    return '';
  }
  var userName = readByUser !== null && readByUser !== void 0 && readByUser.lastName ? "".concat((readByUser === null || readByUser === void 0 ? void 0 : readByUser.firstName) || '', " ").concat(readByUser.lastName) : "".concat((readByUser === null || readByUser === void 0 ? void 0 : readByUser.firstName) || '');
  return t('readBy', {
    userName: userName,
    readAt: formatTimestamp(readConfirmation.readAt)
  });
}
function formatTimestamp(timestamp) {
  var date = new Date(timestamp);
  var dateOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  var timeOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  };
  var formattedDate = date.toLocaleDateString('en-US', dateOptions);
  var formattedTime = date.toLocaleTimeString('en-US', timeOptions);
  var result = "".concat(formattedDate, " at ").concat(formattedTime);
  return result;
}
function DeleteNoteDialog(_ref18) {
  var open = _ref18.open,
    onOpenChange = _ref18.onOpenChange,
    onConfirmDelete = _ref18.onConfirmDelete,
    isDeleting = _ref18.isDeleting,
    noteTitle = _ref18.noteTitle;
  var _useTranslation12 = useTranslation('NotesList'),
    t = _useTranslation12.t;
  return _jsxs(Dialog, {
    open: open,
    onOpenChange: onOpenChange,
    children: [_jsx(Dialog.Heading, {
      children: t('confirmDeleteNoteTitle')
    }), _jsx(Dialog.Content, {
      children: _jsx(Text, {
        as: "p",
        children: t('confirmDeleteNoteContent', {
          noteTitle: noteTitle
        })
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: t('cancel')
      }), _jsx(Button, {
        intent: "negative",
        width: "fill",
        onClick: onConfirmDelete,
        loading: isDeleting,
        children: t('confirmDeleteNote')
      })]
    })]
  });
}
function EmptyStateView() {
  var _useTranslation13 = useTranslation('NotesList'),
    t = _useTranslation13.t;
  return _jsx(Box, {
    pb: 6,
    pt: 6,
    children: _jsxs(Flex, {
      direction: "column",
      align: "center",
      gap: 4,
      children: [_jsx(Flex, {
        align: "center",
        justify: "center",
        children: _jsx(WomanThinkingIllustration, {})
      }), _jsx(Heading, {
        level: 3,
        variant: "titleM",
        align: "center",
        contrast: "high",
        children: t('emptyStateTitle')
      }), _jsx(Text, {
        variant: "bodyM",
        intent: "secondary",
        contrast: "mid",
        align: "center",
        children: t('emptyStateDescription')
      })]
    })
  });
}